import script from "./push-notification-optin.vue?vue&type=script&setup=true&lang=js"
export * from "./push-notification-optin.vue?vue&type=script&setup=true&lang=js"

import "./push-notification-optin.vue?vue&type=style&index=0&id=4d7e9ec8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d7e9ec8"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
